import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as toastr from 'toastr';
import { USER_ID } from 'settings/constants/localStorage';
import {
  AddParticipantsDrawer,
  AppLoading,
  ClientsDrawer,
  MessageAttachmentsDrawer,
  MessagesDrawer,
  NotificationsDrawer,
  QuotesDrawer,
  ThreadContactsDrawer,
  ViewQuoteActivityDrawer,
} from 'components';
import { AgentInvitation } from 'components-antd/Client/AgentInvitation';
import ScreenContext from 'contexts/screen';
import { useResize } from 'hooks';
import { appInitEffect, appLogoutEffect } from 'store/effects/app';
import Hint from './Hint';
import { PageContentContainer } from './PageContentContainer';
import { EmailVerificationModal } from 'features/emailVerification/EmailVerificationModal';
import { MlsAccessModal } from 'features/mlsAccess/MlsAccessModal';
import { PaymentUpdateModel } from 'pages/Paywall/PaymentUpdateModal/PaymentUpdateModal';
import 'styles/global.scss';
import 'toastr/build/toastr.css';
import { getUserId } from 'store/selectors/user';
import Cryptography from 'services/cryptography';
import MobileAppModal from './MobileAppModal';

toastr.options.positionClass = 'toast-bottom-right';

const App = () => {
  const specs = useResize();
  const dispatch = useDispatch();
  const currentUserId = useSelector(getUserId);

  useEffect(() => {
    dispatch(appInitEffect());
  }, []);

  useEffect(() => {
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [currentUserId]);

  const handleStorageChange = (event) => {
    if (!currentUserId) return;

    if (event.key === USER_ID) {
      let storedUserId = event.newValue;

      if (storedUserId) {
        const decryptedUserId = Cryptography.decryptData(storedUserId);
        storedUserId = +decryptedUserId;
      }

      if (storedUserId && storedUserId !== currentUserId) dispatch(appLogoutEffect(true));
    }
  };

  return (
    <ScreenContext.Provider value={specs}>
      <AppLoading>
        <MobileAppModal />
        <PageContentContainer />
        <AgentInvitation />
        <ClientsDrawer />
        <MessagesDrawer />
        <QuotesDrawer />
        <ThreadContactsDrawer />
        <MessageAttachmentsDrawer />
        <ViewQuoteActivityDrawer />
        <AddParticipantsDrawer />
        <NotificationsDrawer />
        <EmailVerificationModal />
        <MlsAccessModal />
        <Hint />
        <PaymentUpdateModel />
      </AppLoading>
    </ScreenContext.Provider>
  );
};

export default App;
